var React = require('react');

function NavigationArrowCarat (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"m17.3750366.62391304c-.2356837-.23188405-.6186697-.23188405-.8543534 0l-7.51241837 7.4057971-7.52714859-7.4057971c-.23568371-.23188405-.61866973-.23188405-.85435346 0-.23568371.23188407-.23568371.60869565 0 .8405797l7.9395951 7.81159421c.11784185.11594203.26514416.17391305.42717671.17391305.14730234 0 .30933489-.05797102.42717674-.17391305l7.93959507-7.81159421c.250414-.23188405.250414-.60869563.0147302-.8405797z","fillRule":"evenodd","transform":"matrix(0 -1 -1 0 10 18)"}));
}

NavigationArrowCarat.defaultProps = {"viewBox":"0 0 10 18"};

module.exports = NavigationArrowCarat;

NavigationArrowCarat.default = NavigationArrowCarat;
